import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter,HashRouter} from 'react-router-dom';
import Contextitem from './context/Contextitem'
import Wishcontainer from './context//Wishcontainer'
import reportWebVitals from './reportWebVitals';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
     
     
      <HashRouter>
      <Wishcontainer>
      <Contextitem>
     <App />
     </Contextitem>
     </Wishcontainer>
     </HashRouter>
    
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
